import { Size } from '@optimus-web/common';
import {
    RadioBackgroundElement,
    RadioElement,
    RadioInnerCircleElement,
    RadioInputElement,
    RadioOuterCircleElement,
} from './style';

export interface RadioProps {
    className?: string;
    checked?: boolean;
    name?: string;
    required?: boolean;
    disabled?: boolean;
    children?: React.ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    inputHidden?: boolean;
    value?: string;
    id?: string;
    size?: Exclude<Size, 'extraLarge'>;
}

export const Radio = ({
    className,
    checked,
    name,
    required,
    disabled,
    inputHidden,
    children,
    onChange,
    onFocus,
    onBlur,
    id,
    size = 'medium',
    ...other
}: RadioProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            onChange(e, !checked);
        }
    };

    return (
        <RadioElement className={className} $disabled={disabled} inputHidden={inputHidden} size={size}>
            <RadioInputElement
                {...other}
                type="radio"
                name={name}
                required={required}
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                id={id}
                aria-checked={checked}
            />
            <RadioBackgroundElement aria-hidden>
                <RadioOuterCircleElement checked={checked} disabled={disabled} />
                <RadioInnerCircleElement checked={checked} disabled={disabled} />
            </RadioBackgroundElement>
        </RadioElement>
    );
};
